import { TicketTier } from '../Types/TicketTier';
import * as constData from './DataConstants';
import * as perkData from './GetPerks';
import { buildDeluxePerks } from './GetPerks';

export function buildTiers(){
  return [
          buildVipTier(),
          buildDeluxeTier(),
          buildDeluxePlusTier()
        ];
}

function buildVipTier(): TicketTier {
  return {
    level: 'VIP',
    cost: constData.vipPrice,
    perks: perkData.buildVipPerks(),
    historicalPricesText: constData.getVipTierHistoryText(),
    previousTierCost: constData.gaPrice,
    previousTierLevel: 'GA'
  };
}

function buildDeluxeTier(): TicketTier {
  return {
    level: 'Deluxe VIP',
    cost: constData.deluxePrice,
    perks: buildDeluxePerks(),
    historicalPricesText: constData.getDeluxeTierHistoryText(),
    previousTierCost: constData.vipPrice,
    previousTierLevel: 'VIP'
  };
}

function buildDeluxePlusTier(): TicketTier {
  return {
    level: 'Deluxe+',
    cost: constData.deluxePlusPrice,
    perks: perkData.buildDeluxePlusPerks(),
    historicalPricesText: constData.getDeluxePlusTierHistoryText(),
    previousTierCost: constData.deluxePrice,
    previousTierLevel: 'Deluxe'
  };
}